<template>
  <v-autocomplete
    variant="outlined"
    density="compact"
    v-model="inputValue"
    :items="vitalStatuss"
    :item-title="(item) => objectTranslator(item, 'VITAL_STATUS_NAME')"
    :item-value="(item) => item.VITAL_STATUS_ID"
    :rules="rules"
  ></v-autocomplete>
</template>

<script>
import { objectTranslator } from "@/helper/translator";
import validator from "@/helper/validator";

export default {
  name: "VitalStatusCard",
  props: {
    modelValue: String,
  },

  data: () => ({
    rules: [validator.required],
  }),

  methods: {
    objectTranslator,
  },

  computed: {
    vitalStatuss: function () {
      return this.$store.state.ref.vitalStatuss;
    },

    inputValue: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      },
    },
  },

  created() {
    this.$store.dispatch("ref/getVitalStatuss");
  },
};
</script>
